import { ChromePicker } from "react-color";

const ColorPicker = ({ handleChange, selectedColor }) => {
  return (
    <ChromePicker
      className="custom-color-Picker w-80 px-2 py-2 mt-3"
      color={selectedColor}
      onChangeComplete={handleChange}
    />
  );
};
export default ColorPicker;
